var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-12"},[_c('button',{staticClass:"text-xs font-semibold rounded-full px-4 py-1 my-2 float-right\n          leading-normal bg-white border border-green text-green\n          hover:bg-green hover:text-white",on:{"click":_vm.publishAll}},[_vm._v("Publish all")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-754715c8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishAllButton.vue
// module id = null
// module chunks = 